<template>
    <a-modal
      :title="title"
      :visible="visible"
      @ok="ok"
      @cancel="cancel"
      okText='确定'
      cancelText='取消'
      destroyOnClose 
      :maskClosable="false"
      width="700px"
    >
      <a-form :form="form" :label-col="{ span: 0 }" class="nomargin" :wrapper-col="{ span: 24 }">
        <a-form-item>
          <span class="formTitle"><span class="requireSpan">*</span>第一步:</span>
          下载模型模板，<a @click="taskDownload">点击下载模板</a>
        </a-form-item>
        <a-form-item>
          <span class="formTitle"><span class="requireSpan">*</span>第二步:</span>
          <span style="line-height: 20px;margin-top: 11px;">
            将需要更新的数据填写到Excel模板中
            <span style="margin-bottom: 0">(<a href="https://newhope1982.feishu.cn/file/boxcn10hudXLPAtmX8uzrfQCRoh" target='_blank'>点击查看填写注意事项</a>)</span>
          </span>
        </a-form-item>
        <a-form-item>
          <span class="formTitle"><span class="requireSpan">*</span>第三步:</span>
          上传填写完成的Excel模板
        </a-form-item>
        <a-form-item>
          <span class="formTitle" style="float: left;"><span class="requireSpan">*</span>模板上传:</span>
          <div style="display: inline-block;">
            <a-upload
              name="file"
              :action="url"
              :headers="headers"
              @change="handleChange"
              :remove="removeFile"
              :file-list="fileList"
              :before-upload="beforeUpload"
            >
              <a-button>上传模板<a-icon type="upload" /></a-button>
            </a-upload>
            <p style="margin-bottom: 0;color: #999;">支持扩展名：.xlsx</p>
          </div>
        </a-form-item>
      </a-form>
      <msg-modal :visible="msgVisible" :configData='configData' @closeMsg="closeMsg" />
      <a-space slot="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button :loading='btnLoading' type='primary' @click="ok">确定</a-button>
      </a-space>
    </a-modal>
</template>
<script>
import {baseUrl} from '@/Utils/url.js'
import MsgModal from './MsgModal.vue'
export default {
  props: ['visible'],
  components: {MsgModal},
  data(){
    return {
      title: <p>模板更新原料数据库 <span style={{'font-size':'12px',color: '#999','margin-left':'10px'}}>模板下载和上传耗时较长，请耐心等候</span></p>,
      saveLoding: false,
      form: this.$form.createForm(this),
      fileList: [],
      url: `${baseUrl}nhf-app/factorystaffraw/myRawExcelImport`,
      headers: {
        Authorization: 'Basic bmhmY2xvdWQ6bmhmY2xvdWRfS3FOUUxUZGFWOTdhbExvMQ==',
        'iot-Auth': `bearer ${window.localStorage.getItem('accessToken')}`
      },
      val: [],
      msgVisible: false,
      configData: {
        status: '',
        msg: []
      },
      btnLoading: false
    }
  },
  watch: {
    visible(val){
      if(val) {
        this.btnLoading = false
        this.msgVisible = false
        this.fileList = []
      }
    },
  },
  methods:{
    async ok(){
      if(this.fileList.length === 0){
        this.$message.warning('请选择上传模板')
        return
      }
      this.btnLoading = true
      const formData = new FormData();
      this.fileList.forEach(file => {
        formData.append('file', file);
      });
      formData.append('factoryId',window.localStorage.getItem('factoryId'))
      let res = await this.$post(this.url,formData)
      this.btnLoading = false
      this.showMsg(res,this.fileList)
      // this.$emit('closeExport','refresh')
    },
    cancel(){
      this.$emit("closeExport");
    },
    async taskDownload(){
      // let taskName = '模板原料'
      let factoryId = window.localStorage.getItem('factoryId')
      this.$fileDownload(`/nhf-app/factorystaffraw/myRawDownload`,{factoryId}).catch(
        (e) => {
          e.message && this.$message.error(e.message);
        }
      );
      // console.log('rrr',rrr)

      // const res = await this.$http(`/nhf-app/factorystaffraw/myRawDownload`,{params: {factoryId},method: 'get',responseType:'arraybuffer'})
      // this.downloadExcel(res,{taskName})
    },
    downloadExcel(file,item){
      new Promise((res,rej) => {
        this.downloading = true
        const {taskName} = item
        let blob = new Blob([file], { type:'application/vnd.ms-excel;charset=utf-8'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = `${taskName}.xlsx`;
        a.click() 
        window.URL.revokeObjectURL(a.href)
        objectUrl ? res(objectUrl) : rej(null)
      }).finally(()=>{
        this.downloading = false
      })
    },
    handleChange(res){
      let {file,fileList} = res || {}
      let {response} = file || {}
      this.showMsg(response,fileList)
    },
    showMsg(response,fileList){
      if(response){
        let {data,success} = response || {}
        let {msg,allSuccess} = data || {}
        if(success){
          if(allSuccess){
            this.configData = {
              status: 'success',
              title: <p style={{'font-size': '16px',color: '','font-weight': 'bold'}}><a-icon style={{'font-size': '14px',color: '#52c41b','margin-right': '10px'}} type="check-circle" />提交成功</p>,
              content: ['原料数据导入成功，关闭弹窗即可查看。']
            }
          }else{
            this.configData = {
              status: 'warning',
              content: msg,
              title: <p style={{'font-size': '14px',color: '','font-weight': 'bold'}}><a-icon style={{'font-size': '14px',color: '#faad14','margin-right': '10px'}} type="info-circle" />部分原料导入失败，请修改后再上传</p>,
            }
          }
        }else{
          this.configData = {
            status: 'error',
            title: <p style={{'font-size': '14px',color: '','font-weight': 'bold'}}><a-icon type="close-circle"  style={{'font-size': '14px',color: '#f5222d','margin-right': '10px'}} />导入失败</p>,
            content: ['由于网络等原因无法导入，请稍后尝试！'],
          }
        }
        if(fileList.length > 0) this.msgVisible = true
      }
    },
    async closeMsg(type){
      console.log(type)
      this.msgVisible = false
      // this.$emit("closeExport");
      if(type) {
        this.btnLoading = true
        const formData = new FormData();
        this.fileList.forEach(file => {
          formData.append('file', file);
        });
        formData.append('factoryId',window.localStorage.getItem('factoryId'))
        let res = await this.$post(this.url,formData)
        this.btnLoading = false
        this.showMsg(res,this.fileList)
      }else{
        this.$emit('closeExport','refresh')
      }
    },
    removeFile(){
      this.fileList = []
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false
    },
  }
}
</script>
<style lang="scss" scoped>
.cover{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1000000;
  .comfirmContent{
    width: 350px;
    height: 160px;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -175px;
    margin-top: -200px;
    background: #fff;
    border-radius: 5px;
  }
  .footer{
    position: absolute;
    bottom: 20px;
    right: 20px;
    & > div{
      float: right;
    }
  }
}
</style>
<style lang="scss">
.nomargin{
  .ant-form-item{
    margin-bottom: 0;
  }
}
</style>